@if (call.isOpen()) {
  @if (visibleHere()) {
    @if (call.displayMode() === 'mini') {
      <div
        [class]="containerClasses()"
        cdkDrag
        cdkDragBoundary="body"
        [cdkDragFreeDragPosition]="dragPosition()"
        (cdkDragEnded)="onDragEnded($event)">
        <ng-container [ngTemplateOutlet]="body" />
      </div>
    } @else {
      <div [class]="containerClasses()">
        <ng-container [ngTemplateOutlet]="body" />
      </div>
    }
  }
}

<ng-template #body>
  <icaredx-telehealth-call-window
    [class]="windowClasses()"
    [canExpand]="call.sideAllowed()"
    [phase]="call.phase()"
    [state]="engine.state()"
    [micMuted]="engine.isMicMuted()"
    [cameraOn]="engine.isCameraOn()"
    [screenSharing]="engine.isScreenSharingOn()"
    [screenShareSupported]="engine.screenShareSupported"
    [remoteConnected]="engine.remoteConnected()"
    [errorMessage]="engine.errorMessage()"
    [remoteView]="engine.remoteView()"
    [remoteScreenView]="engine.remoteScreenView()"
    [localView]="engine.localView()"
    [cameras]="engine.cameras()"
    [microphones]="engine.microphones()"
    [speakers]="engine.speakers()"
    [selectedCameraId]="engine.selectedCameraId()"
    [selectedMicrophoneId]="engine.selectedMicrophoneId()"
    [selectedSpeakerId]="engine.selectedSpeakerId()"
    [endsAtUtc]="call.activeAppointment()?.endUtc ?? null"
    [connectedAtMs]="engine.connectedAtMs()"
    [connectionQuality]="engine.connectionQuality()"
    [displayMode]="call.displayMode()"
    [title]="callTitle()"
    [scheduleLabel]="scheduleLabel()"
    [timeZone]="displayTimeZone()"
    [remoteDisplayName]="counterpartyName()"
    [localDisplayName]="localName()"
    [primaryActionLabel]="primaryActionLabel()"
    (toggleMute)="onToggleMute()"
    (toggleCamera)="onToggleCamera()"
    (toggleScreenShare)="onToggleScreenShare()"
    (hangUp)="onHangUp()"
    (toggleSize)="onToggleSize()"
    (join)="onJoin()"
    (rejoin)="onRejoin()"
    (selectCamera)="onSelectCamera($event)"
    (selectMicrophone)="onSelectMicrophone($event)"
    (selectSpeaker)="onSelectSpeaker($event)" />

  @if (showChat()) {
    <icaredx-telehealth-chat
      [class]="chatClasses()"
      [theme]="chatTheme()"
      [showHeader]="call.displayMode() === 'full'" />
  }
</ng-template>
